export default __webpack_public_path__ + "static/harrison_tang-02b5854460e67bedcb90dd83c0d05511.jpg";